import { AgGridReact } from "ag-grid-react";
import Cookies from "js-cookie";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { FetchDataTypes } from "../../api/api";
import { Grid, GridReadyEvent } from "ag-grid-community";
import {
  currencyFormat,
  formateAsPercent,
  formateDataCurr,
  formateDataPrec,
} from "../../utils/types";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import clsx from "clsx";
import _ from "lodash";

const FundRebalance = () => {
  const dataGridRef = useRef(null);
  const [rowData, setRowData] = useState<any>();
  const [rowRebalanceData, setRowRebalanceData] = useState();
  const [newTarger, setNewTarget] = useState<any>();
  const [first, setfirst] = useState([]);
  const [rebalanceTrades, setRebalanceTrades] = useState(false);
  const [showErrormsg, setShowErrormsg] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState();
  const [defaultParticipent, setDefaultParticipent] = useState();
  
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("RebalanceParticipant", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowData(response);
      });
  }, []);

  function handleChangeParticipant(e: any) {
    setSelectedParticipant(e.target.value);
  }

  console.log(defaultParticipent);
  const participantList = _.uniqBy(rowData, "participantName");
  const defaultparticipent = _.filter(participantList, {
    participantName: !selectedParticipant
      ? "AK Retirement Plan"
      : selectedParticipant,
  });
  const participantFrom = _.filter(rowData, {
    participantName: !selectedParticipant
      ? "AK Retirement Plan"
      : selectedParticipant,
  });
  const participantBalance = _.find(rowData, {
    participantName: !selectedParticipant
      ? "AK Retirement Plan"
      : selectedParticipant,
  });
  console.log(rowData);

  function handleSubmit() {
    setShowErrormsg(true);
  }
  function handleCloseClick(){
    setShowErrormsg(false);
  }



  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none">
        <div className="col-sm-3 w-100 py-3 justify-content-between">
          <h5 className="card-title float-start w-100">
            Fund Rebalance Trades </h5>
            
          <div className="row content-pane">
            <div className="col-12 my-3">
              <form id="fundTransferForm" className="tradeForm">
                <div className="row">
                  <div className="row">
                    <div className="mb-3 col-md-2">
                      <label>Participant</label>
                    </div>
                    <div className="mb-3 col-md-4 error-placeholder w-25">
                      <select
                        onChange={handleChangeParticipant}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        {participantList?.map((e: any) => {
                          return (
                            <option
                              value={e.participantName}
                              key={e.participantName}
                              selected={
                                e.participantName === "AK Retirement Plan"
                              }
                            >
                              {e.participantName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="mb-3 col-md-2">
                      <label>Balance:</label>
                    </div>
                    <div className="mb-3 col-md-4 d-flex align-items-center">
                      <strong>
                        {selectedParticipant
                          ? "$" + currencyFormat(participantBalance?.marketValue)
                          : participantBalance?.marketValue
                          ? "$" + currencyFormat(participantBalance?.marketValue)
                          : "$0"}
                      </strong>
                    </div>
                  </div>
                  <div className="row">
                    <div className="mb-3 col-md-2">
                      <label>Transfer Type:</label>
                    </div>
                    <div className="mb-3 col-md-4">
                      <label className="form-check text-small form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="validation-required"
                          value="$"
                          checked
                        />
                        <span className="form-check-label"> $ </span>
                      </label>
                      <label className="form-check text-small form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="validation-required"
                          value="%"
                        />
                        <span className="form-check-label"> % </span>
                      </label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {showErrormsg 
          ?  <div
              className="alert alert-danger alert-dismissible statusAlert"
              role="alert"
             >
              <div className="alert-message">
                 Total Buy Or Sell amount should equal to 0. Current net amount =
             </div>
               <button
               type="button"
                className="btn-close btn-close-white"
                 data-bs-dismiss="alert"
                aria-label="Close"
                onClick={handleCloseClick}
              ></button>
             </div>
            
          : null}
        <div className="card-body p-0">
          <div className="col-sm-12">
            
                <table
                  id="UpdateTargets"
                  className="table table-striped my-0"
                  style={{ maxHeight: "550px" }}
                >
                  <thead>
                    <tr style={{ height: "42px", verticalAlign: "middle" }}>
                      <th className="text-Start ">Fund</th>

                      <th className="d-none d-xl-table-cell text-end ">
                        Balances
                      </th>
                      <th className="d-none d-xl-table-cell text-end ">
                        Actual %
                      </th>
                      <th className="d-none d-xl-table-cell text-end ">
                        Target Market Value
                      </th>
                      <th className="d-none d-xl-table-cell text-end ">
                        Target %
                      </th>
                      <th className="d-none d-xl-table-cell text-start ">
                      Buy/Sell
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ height: "inherit" }}>
                    {participantFrom &&
                      participantFrom?.map((e: any, index: any) => {
                        return (
                          <tr key={index}>
                            <td className="text-start">{e.fundName}</td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.marketValue >= 0 ? (
                                <>
                                  {e.marketValue === null
                                    ? "NA"
                                    : "$" + currencyFormat(e.marketValue)}
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      "$" +
                                      currencyFormat(e.marketValue).slice(1) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.actualPct >= 0 ? (
                                <>
                                  {e.actualPct === null
                                    ? "NA"
                                    : formateAsPercent(e.actualPct)}
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      formateAsPercent(e.actualPct).slice(1) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.targetMarketValue >= 0 ? (
                                <>
                                  {e.targetMarketValue === null
                                    ? "NA"
                                    : "$" + currencyFormat(e.targetMarketValue)}
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      "$" +
                                      currencyFormat(e.targetMarketValue).slice(
                                        1
                                      ) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td className="d-none d-xl-table-cell text-end ">
                              {e.targetPct >= 0 ? (
                                <>
                                  <input
                                    type="number"
                                    readOnly
                                    className="form-control"
                                    placeholder={
                                      e.targetPct === null
                                        ? "NA"
                                        : formateAsPercent(e.targetPct)
                                    }
                                  />
                                </>
                              ) : (
                                <>
                                  <span className="text-danger">
                                    {"(" +
                                      formateAsPercent(e.targetPct).slice(1) +
                                      ")"}
                                  </span>
                                </>
                              )}
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control w-75"
                                value={e.buyOrSell}
                                
                                
                               
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              
             
            
          </div>
          <div className="col-12 d-flex m-2 align-items-center justify-content-end">
                <div className="float-end text-start">
                
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={handleSubmit}
                    >
                      Cancel
                    </button>
                  <button
                    type="submit"
                    className={clsx(
                      "btn btn-primary",
                    )}
                    onClick={ handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
        </div>
      </div>
    </div>
  );
};

export { FundRebalance };
